import { type IExpression } from '../IExpression.ts';
import { ExpressionRepository } from '../repository/ExpressionsRepository.ts';
import { expressionLogger } from '../utils/expressionLogger.ts';
import { type IReference } from './IReference.ts';

const expressionReferencesCache = new WeakMap<IExpression, IReference[]>();

/**
 * Ottiene tutte le Reference utilizzate in un'espressione.
 * Utilizza una BFS iterativa con queue per evitare ricorsione.
 */
export function collectExpressionReferences(
  expression: IExpression | null | undefined,
): IReference[] {
  if (expression == null || typeof expression !== 'object') return [];

  const cached = expressionReferencesCache.get(expression);
  if (cached) return cached;

  const references: IReference[] = [];
  const queue: IExpression[] = [expression];

  // BFS: usiamo l'indice per evitare shift() O(n)
  let i = 0;
  while (i < queue.length) {
    const expr = queue[i++];

    const expressionType = ExpressionRepository.get(expr.type);
    if (!expressionType) {
      // biome-ignore format: <tbd>
      expressionLogger.warn(`[collectExpressionReferences] Expression type not found`, expr);
      continue;
    }

    // getReferences riceve un `collect` che non è ricorsivo,
    // ma accoda le sotto-espressioni per il prossimo ciclo BFS
    const directRefs = expressionType.getReferences(expr, child => {
      queue.push(child);
      return [];
    });

    for (const ref of directRefs) references.push(ref);
  }

  expressionReferencesCache.set(expression, references);
  return references;
}
